import { render } from "./PaulSection.vue?vue&type=template&id=b78ca386&scoped=true"
import script from "./PaulSection.vue?vue&type=script&lang=js"
export * from "./PaulSection.vue?vue&type=script&lang=js"

import "./PaulSection.vue?vue&type=style&index=0&id=b78ca386&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b78ca386"]])

export default __exports__